import { useChatStore } from '../../../store/chatStore';

interface ReplyQuoteProps {
  roomId: string;
  /** 답장 대상 메시지 id. null/undefined 면 렌더 안 함. */
  replyToId: string | null | undefined;
}

/**
 * ReplyQuote — 메시지 말풍선 위 인용 미리보기.
 *
 * 원본은 로컬 messagesByRoom 에서 lookup(catch-up 독립). 못 찾으면(옛 메시지) generic 표시 —
 * 후속에 백엔드 replyToPreview 임베드로 보강 예정.
 */
export function ReplyQuote({ roomId, replyToId }: ReplyQuoteProps) {
  const original = useChatStore((s) =>
    replyToId ? s.messagesByRoom[roomId]?.find((m) => m.id === replyToId) : undefined,
  );
  if (!replyToId) return null;
  const text = original ? snippet(original.content) : '원본 메시지';
  return (
    <div className="chat-reply-quote">
      <span className="chat-reply-quote-bar" aria-hidden />
      <span className="chat-reply-quote-text">{text}</span>
    </div>
  );
}

function snippet(s: string): string {
  const oneLine = s.replace(/\n/g, ' ').trim();
  return oneLine.length > 60 ? `${oneLine.slice(0, 60)}…` : oneLine;
}
